import { ORDERS } from '@shared/constants';
import { graphQuery } from '@services/commService';
import { staffListOffset } from './helpers';
import { ROLES } from './consts';

export const getStaff = async (offset, sortBy = 'FULL_NAME', order = ORDERS.ASC, searchText = '') => {
  const limit = staffListOffset;

  // Format roles as GraphQL array
  const rolesArray = `[${Object.keys(ROLES).join(', ')}]`;
  const searchParam = searchText ? `, search: "${searchText}"` : '';

  const query = `
    {
      allUsers(
        offset: ${offset},
        limit: ${limit},
        roles: ${rolesArray},
        sort: {sortBy: ${sortBy}, direction: ${order}}${searchParam}
      ) {
        id
        roles
        fullName
        email
        businessUnitsInfo {
          id
          name
        }
      }
    }
  `;

  const res = await graphQuery(query, true);
  return res.data;
};

export const getUser = async (id) => {
  const query = `
  {
    user (id: "${id}") {
      fullName
      avatar
      information {
        email
        username
        startDate
        age
        state
        country
        mentors {
          label
          attached
        }
        courses {
          label
          attached
        }
      },
      personalProgram: null, // TODO write schema
      log: null, // TODO write schema
    }
  }
  `;
  const res = await graphQuery(query, true);
  return res.data;
};

export const getCountStaff = async () => {
  const roles = `[${Object.keys(ROLES).join(', ')}]`;
  const query = `
    {
      allUsersCount (roles: ${roles})
    }
  `;
  const res = await graphQuery(query, true);
  return res.data;
};
